require('./managePopupNotificationHeader.i18n.json');
require('./managePopupNotificationHeader.tpl.html');
require('./managePopupNotificationHeaderController.js');

const ManagePopupNotificationHeaderComponent = {
    templateUrl: '/configuration/popupNotification/managePopupNotification/header/managePopupNotificationHeader.tpl.html',
    controller: 'managePopupNotificationHeaderController',
    bindings: {
        templateId: '<'
    }
};

angular.module('ums.configuration')
    .component('uiManagePopupNotificationHeader', ManagePopupNotificationHeaderComponent);
